'use client'

import { useEffect, useState } from 'react'
import { useCookieConsent } from '@alvaromartinezreche98-svg/cookie-consent'

type Props = {
  ga4?: string
  plausibleDomain?: string
}

// Renders analytics tags only after the visitor has granted the matching
// category. Mounted inside <ConsentProvider>, so it has access to the hook.
export default function ConsentScripts({ ga4, plausibleDomain }: Props) {
  const { hasConsented, preferences, isHydrating } = useCookieConsent()
  const [analyticsOn, setAnalyticsOn] = useState(false)

  useEffect(() => {
    if (isHydrating) return
    setAnalyticsOn(hasConsented && Boolean(preferences.analytics))
  }, [hasConsented, preferences.analytics, isHydrating])

  if (!analyticsOn) return null

  return (
    <>
      {ga4 && (
        <>
          <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga4}`} />
          <script
            dangerouslySetInnerHTML={{
              __html: `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${ga4}');`,
            }}
          />
        </>
      )}
      {plausibleDomain && (
        <script defer data-domain={plausibleDomain} src="https://plausible.io/js/script.js" />
      )}
    </>
  )
}
